export default __webpack_public_path__ + "static/media/img5.0c410862.jpg";